import { render, staticRenderFns } from "./PerformanceImport.vue?vue&type=template&id=47bf781a&scoped=true&"
import script from "./PerformanceImport.vue?vue&type=script&lang=js&"
export * from "./PerformanceImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf781a",
  null
  
)

export default component.exports